import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { gql } from "apollo-boost";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Element } from "react-scroll";
import { v4 as uuidv4 } from "uuid";

import { addOrderPosition } from "../store/actions/order";

import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import TextField from "@material-ui/core/TextField";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import ChooseMaterial from "../components/creator/ChooseMaterial";
import ChooseProduct from "../components/creator/ChooseProduct";
import ChooseSystem from "../components/creator/ChooseSystem";
import ChooseColors from "../components/creator/ChooseColors";
import ChooseType from "../components/creator/ChooseType";
import ChooseShades from "../components/creator/ChooseShades";
import { generateLanguage } from "../components/Navbar";

import SummaryTable from "../components/SummaryTable";

import { scrollTo, scrollToTop } from "../helpers/scroll";
import { getLocale } from "../helpers/locales";
import { hasShades } from "../helpers";

const FOCUS = {
  product: "product",
  material: "material",
  system: "system",
  type: "type",
  colorInterior: "colorInterior",
  colorExterior: "colorExterior",
  width: "width",
  height: "height",
  count: "count",
  shades: "shades",
  cta: "cta"
};

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: "15rem",
    [theme.breakpoints.up("md")]: {
      textAlign: "center"
    }
  },
  box: {
    "& > *:not(:last-child)": {
      marginRight: props => (props.isMobile ? 0 : theme.spacing(3))
    },
    "& > *:not(:first-child)": {
      marginTop: props => (props.isMobile ? theme.spacing(3) : 0)
    },
    "& > *": {
      flexGrow: 1,
      width: props => (props.isMobile ? "100%" : 300),
      maxWidth: 300,
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%"
      }
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "center"
    }
  },
  container: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2)
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  fab: {
    position: "fixed",
    // TODO: move to bottom-right on mobile
    bottom: theme.spacing(3),
    left: theme.spacing(3)
  },
  textField: {
    width: 300,
    maxWidth: 300,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
      minWidth: "100%"
    }
  }
}));

function formatResult({
  count,
  selectedMaterial,
  selectedProduct,
  selectedSystem,
  selectedType,
  selectedColors,
  selectedShades,
  width,
  height
}) {
  return {
    count,
    material: selectedMaterial,
    product: selectedProduct,
    system: selectedSystem,
    type: selectedType,
    color: selectedColors.color,
    colorInterior: selectedColors.interior,
    colorExterior: selectedColors.exterior,
    selectedShades,
    width,
    height
  };
}

function handleAddToOrderClick(addOrderPosition, resetValues, result, history) {
  const id = uuidv4();

  addOrderPosition({ ...result, id });
  resetValues();
  const locale = getLocale();
  history.replace(`/${locale}`);
}

function Creator({
  addOrderPosition,
  decrementStep,
  defaultColor,
  defaultSystem,
  history,
  incrementStep,
  location,
  locale,
  step
}) {
  useEffect(() => {
    scrollToTop();
  }, []);

  // TODO: Change to mui breakpoints
  const isMobile = useMediaQuery("(max-width:600px)");

  const { t } = useTranslation();
  const classes = useStyles({ isMobile });

  // State
  const [focus, setFocus] = useState(FOCUS.product);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [selectedSystem, setSelectedSystem] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedColors, setSelectedColors] = useState({
    color: null,
    interior: null,
    exterior: null
  });
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const [count, setCount] = useState(1);
  const [selectedShades, setSelectedShades] = useState(false);

  const completed =
    !!selectedProduct &&
    !!selectedMaterial &&
    !!selectedSystem &&
    !!selectedType &&
    ((!!selectedColors.interior && !!selectedColors.exterior) ||
      !!selectedColors.color) &&
    !!width &&
    !!height;

  const result = formatResult({
    count,
    selectedProduct,
    selectedMaterial,
    selectedSystem,
    selectedType,
    selectedColors,
    selectedShades,
    width,
    height
  });

  // Actions
  const resetValues = () => {
    setSelectedProduct(null);
    setSelectedMaterial(null);
    setSelectedSystem(null);
    setSelectedType(null);
    setSelectedColors({
      color: null,
      interior: null,
      exterior: null
    });
    setWidth(null);
    setHeight(null);
    setSelectedShades(false);
  };

  console.log({ focus });
  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        <h1>{t("creator.add product")}</h1>
      </Container>
      <Container className={classes.container}>
        <ChooseProduct
          focus={focus === FOCUS.product}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          onSelect={() => {
            setSelectedMaterial(null);
            setSelectedSystem(null);
            setSelectedType(null);
            setSelectedColors({
              color: null,
              interior: null,
              exterior: null
            });
            setWidth(null);
            setHeight(null);
            setSelectedShades(false);

            scrollTo("material");
            setFocus(FOCUS.material);
          }}
        />
      </Container>
      <Element name="material" className="element">
        {!!selectedProduct ? (
          <Container className={classes.container}>
            <ChooseMaterial
              focus={focus === FOCUS.material}
              productId={selectedProduct.id}
              selectedMaterial={selectedMaterial}
              setSelectedMaterial={setSelectedMaterial}
              onSelect={() => {
                setSelectedSystem(null);
                setSelectedType(null);
                setSelectedColors({
                  color: null,
                  interior: null,
                  exterior: null
                });
                setWidth(null);
                setHeight(null);
                setSelectedShades(false);

                scrollTo("system");
                setFocus(FOCUS.system);
              }}
            />
          </Container>
        ) : null}
      </Element>
      <Element name="system" className="element">
        {!!selectedMaterial ? (
          <Container className={classes.container}>
            <ChooseSystem
              focus={focus === FOCUS.system}
              defaultSystem={defaultSystem}
              materialId={selectedMaterial.id}
              productId={selectedProduct.id}
              selectedSystem={selectedSystem}
              setSelectedSystem={setSelectedSystem}
              locale={locale}
              onSelect={() => {
                setSelectedType(null);
                setSelectedColors({
                  color: null,
                  interior: null,
                  exterior: null
                });
                setWidth(null);
                setHeight(null);
                setSelectedShades(false);

                scrollTo("type");
                setFocus(FOCUS.type);
              }}
            />
          </Container>
        ) : null}
      </Element>
      <Element name="type" className="element">
        {!!selectedSystem ? (
          <Container className={classes.container}>
            <ChooseType
              focus={focus === FOCUS.type}
              materialId={selectedMaterial.id}
              productId={selectedProduct.id}
              selectedType={selectedType}
              setSelectedType={setSelectedType}
              systemId={selectedSystem.id}
              onSelect={() => {
                setSelectedColors({
                  color: null,
                  interior: null,
                  exterior: null
                });
                setWidth(null);
                setHeight(null);
                setSelectedShades(false);

                scrollTo("colors");
                setFocus(FOCUS.colorInterior);
              }}
              onReturn={() => {
                setSelectedColors({
                  color: null,
                  interior: null,
                  exterior: null
                });
                setWidth(null);
                setHeight(null);
                setSelectedShades(false);
              }}
            />
          </Container>
        ) : null}
      </Element>
      <Element name="colors" className="element">
        {!!selectedType ? (
          <Container className={classes.container}>
            <ChooseColors
              defaultColor={defaultColor}
              focusColorExterior={focus === FOCUS.colorExterior}
              focusColorInterior={focus === FOCUS.colorInterior}
              materialId={selectedMaterial.id}
              onSelectColor={() => {
                setWidth(null);
                setHeight(null);
                setSelectedShades(false);
                scrollTo("dimensions");
                setFocus(FOCUS.width);
              }}
              onSelectColorExterior={() => {
                setWidth(null);
                setHeight(null);
                setSelectedShades(false);
                if (selectedColors.interior) {
                  scrollTo("dimensions");
                  setFocus(FOCUS.width);
                } else {
                  setFocus(FOCUS.colorInterior);
                }
              }}
              onSelectColorInterior={() => {
                setWidth(null);
                setHeight(null);
                setSelectedShades(false);
                if (selectedColors.exterior) {
                  scrollTo("dimensions");
                  setFocus(FOCUS.width);
                } else {
                  setFocus(FOCUS.colorExterior);
                }
              }}
              productId={selectedProduct.id}
              selectedColors={selectedColors}
              selectedProduct={selectedProduct}
              selectedSystem={selectedSystem}
              setSelectedColors={setSelectedColors}
              systemId={selectedSystem.id}
            />
          </Container>
        ) : null}
      </Element>
      <Element name="dimensions" className="element">
        {(!!selectedColors.interior && !!selectedColors.exterior) ||
        !!selectedColors.color ? (
          <Container className={classes.container}>
            <h2>{t("categories.dimensions")}</h2>
            <Box className={classes.box} display="flex" flexWrap="wrap">
              <TextField
                autoFocus={focus === FOCUS.width}
                className={classes.textField}
                id="width"
                label={t("creator.total width")}
                type="number"
                InputLabelProps={{
                  shrink: true
                }}
                variant="outlined"
                value={width}
                onBlur={() => {
                  if (height) {
                    scrollTo("count");
                    setFocus(FOCUS.count);
                  } else {
                    setFocus(FOCUS.height);
                  }
                }}
                onChange={event => {
                  setWidth(event.target.value);
                }}
              />
              <TextField
                autoFocus={focus === FOCUS.height}
                className={classes.textField}
                id="height"
                label={t("creator.total height")}
                type="number"
                InputLabelProps={{
                  shrink: true
                }}
                variant="outlined"
                value={height}
                onBlur={() => {
                  if (width) {
                    scrollTo("count");
                    setFocus(FOCUS.count);
                  } else {
                    setFocus(FOCUS.width);
                  }
                }}
                onChange={event => {
                  setHeight(event.target.value);
                  setSelectedShades(false);
                }}
              />
            </Box>
          </Container>
        ) : null}
      </Element>
      <Element name="count" className="element">
        {!!width && !!height ? (
          <Container className={classes.container}>
            <h2>{t("categories.count")}</h2>
            <div>
              <TextField
                autoFocus={focus === FOCUS.count}
                className={classes.textField}
                id="count"
                label={t("creator.count")}
                type="number"
                InputLabelProps={{
                  shrink: true
                }}
                variant="outlined"
                value={count}
                onBlur={() => {
                  scrollTo(
                    hasShades(selectedProduct.id) ? "shades" : "summary"
                  );
                  setFocus(FOCUS.shades);
                }}
                onChange={event => {
                  setCount(event.target.value);
                }}
              />
            </div>
          </Container>
        ) : null}
      </Element>
      {completed && hasShades(selectedProduct.id) ? (
        <Element name="shades" className="element">
          <Container className={classes.container}>
            <>
              <h2>{t("categories.shades")}</h2>
              <ChooseShades
                focus={focus === FOCUS.shades}
                label={t("creator.shades")}
                selectedShades={selectedShades}
                setSelectedShades={setSelectedShades}
              />
            </>
          </Container>
        </Element>
      ) : null}
      <Element name="summary" className="element">
        <Container className={classes.container}>
          {completed ? (
            <>
              <h2>{t("creator.summary")}</h2>
              <SummaryTable
                color={selectedColors.color}
                colorInterior={selectedColors.interior}
                colorExterior={selectedColors.exterior}
                count={count}
                material={selectedMaterial}
                product={selectedProduct}
                selectedShades={selectedShades}
                system={selectedSystem}
                type={selectedType}
                width={width}
                height={height}
              />
              <Box mt={2} display="flex" justifyContent="flex-end">
                <Button
                  color="primary"
                  variant="contained"
                  disabled={!completed}
                  onClick={() =>
                    handleAddToOrderClick(
                      addOrderPosition,
                      resetValues,
                      result,
                      history
                    )
                  }
                  disabled={!completed}
                >
                  {t("creator.add to valuation")}
                </Button>
              </Box>
            </>
          ) : null}
        </Container>
      </Element>
      <Link to={generateLanguage(locale, location)}>
        <Fab className={classes.fab} variant="outlined">
          <ArrowBackIcon className={classes.extendedIcon} />
          {t("creator.back")}
        </Fab>
      </Link>
    </div>
  );
}

export const DRAFTS_QUERY = gql`
  query DraftsQuery {
    windowsPVC {
      id
      name
      image
    }
  }
`;

const mapStateToProps = ({
  defaults: { color: defaultColor, system: defaultSystem },
  order
}) => {
  return { defaultColor, defaultSystem, order };
};
const mapDispatchToProps = dispatch => {
  return { addOrderPosition: value => dispatch(addOrderPosition(value)) };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Creator));
